import React, { FC } from 'react';
import DashboardTable from 'components/DashboardTable';
import UserTable from 'components/UserTable';
import { Dashboard } from 'models/dashboard';
import { User } from 'models/user';
import './AdminHome.scss';

interface AdminHomeProps {
    dashboards: Dashboard[];
    users: User[];
}

const AdminHome: FC<AdminHomeProps> = (props) => (
    <div className="admin-home" data-testid="admin-home">
        <DashboardTable dashboards={props.dashboards} allowCreate={true} />
        <UserTable users={props.users} allowCreate={true} />
    </div>
);

export default AdminHome;
